// This function will reserialize our customizable products variants
// The important part is that is gets the variant image to display from the bundleMainProduct images
// why ? -> In shopify, the main product of a bundle contains all the images of its customizable products (for example, a plant will contain all of its customizable pot variants images)
// this allows us to display branded pots for each plant
export function serializeCustomizerProductVariants(
  variants,
  product,
  bundleMainProduct,
) {
  function generateRandomColor() {
    const letters = '0123456789ABCDEF'
    let color = '#'
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)]
    }
    return color
  }

  const color = generateRandomColor()
  const images = bundleMainProduct?.images ? bundleMainProduct?.images : null

  const serializedVariants = variants
    ?.map((variant, i) => {
      // First we get our current variant SKU. Our customizable products
      const sku = variant.sku
      const skuParts = sku.split('-')

      // Shopify api calls default variant images to the product featured image
      // to know if our variant has a proper image contributed, we will check if the variant image is the same as the product featured images
      // if yes and the url contains our sku -> contributed image
      // if yes and the url doesnt contain our sku -> no contributed image
      // no correspondance between variant image and featured image -> contributed image
      const variantImage =
        product?.featuredImage?.url === variant?.image?.src
          ? variant?.image?.src.includes(skuParts[skuParts.length - 1])
            ? variant?.image?.src
            : null
          : variant?.image?.src

      // ByCharlot logic is that a variant that doesnt have a contributed image shouldn't be displayed in the customizer
      // Once we checked if the variant has an image, we can search through the mainBundleProduct images to see which one contains the current sku in its URL
      const variantPreviewImage = variantImage
        ? images?.find((image) => {
            if (image.url.includes(skuParts[skuParts.length - 1])) {
              return true
            }
          })?.url ?? null
        : null

      // if we have a variant preview Image, set the index based on the mainProduct images order
      const variantIndex = variantPreviewImage
        ? images.findIndex((image) => image.url === variantPreviewImage)
        : null

      // We will use this fallback image to make sure we always have something to display in the customizer
      const fallbackImage =
        bundleMainProduct?.featuredImage?.url ?? product?.featuredImage?.url

      const result =
        variantImage && variant?.availableForSale
          ? {
              ...variant,
              image: {
                ...variant?.image,
                ...(variantPreviewImage ? { src: variantImage } : {}),
              },
              variantImage: {
                src: variantPreviewImage ?? fallbackImage,
              },
              variantIndex,
            }
          : null

      return result
    })
    .filter(Boolean)

  return serializedVariants ?? []
}
